import React, { Fragment } from 'react'

function BureauReport({ report }) {
    return (
        <>
        {(report?.err || !report) ?
            <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                <td colSpan="2" className='px-4 py-3 font-bold text-center text-gray-500 dark:text-gray-400'>
                    {report?.err || "No credit bureau data available"}
                </td>
            </tr>
        :
        (report?.message === "We are unable to process your request at this moment, please try again later or contact our customer service team, thank you!" || report?.message === "success") ?
            <tr colSpan="2" className="px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:text-gray-700 hover:bg-gray-50">
                <td colSpan="2" className='px-4 py-3 font-bold text-center'>
                    {report?.message === "success" ? "No records found! Thank you" : report?.message}
                </td>
            </tr>
        :
        report?.response?.message === "No records found! Thank You!" ?
            <tr colSpan="2" className="px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:text-gray-700 hover:bg-gray-50">
                <td colSpan="2" className='px-4 py-3 font-bold text-center'>
                    {report?.response?.message}
                </td>
            </tr>
        : 
        <Fragment>
            <tr colSpan="2" className="px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:text-gray-700 hover:bg-gray-50">
                <td className='px-4 py-3 font-bold text-gray-800 dark:text-gray-200'>Personal Information</td>
            </tr>

            {report?.telephoneHistory.map((item, index) => (
                <tr key={index + 15} className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Mobile Phone Number
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.mobileTelephoneNumber}
                    </td>
                </tr>
            ))}

            {report?.identificationHistory.map((item, index) => (
                <tr key={index + 11} className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Idenfitication Type / Number
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.identificationType} - {item?.identificationNumber}
                    </td>
                </tr>
            ))}

            {report?.addressHistory.map((item, index) => (
                <tr key={index + 10} className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Address
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.address1} - {item?.addressTypeInd}
                    </td>
                </tr>
            ))}

            {report?.employmentHistory.map((item, index) => (
                <tr key={index + 12} className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Employment
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.occupation}
                    </td>
                </tr>
            ))}



            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'></td>
                <td className='px-4 py-3'></td>
            </tr>

            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3 font-bold text-gray-800 dark:text-gray-200'>Delinquency Rating</td>
            </tr>

            <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                    Highest Delinquency Rating
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                    {report?.highestDelinquencyRating?.highestDelinquencyRating}
                </td>
            </tr>




            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'></td>
                <td className='px-4 py-3'></td>
            </tr>

            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3 font-bold text-gray-800 dark:text-gray-200'>Credit Account Summary</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Monthly Installment</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalMonthlyInstalmentGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Outstanding Debt</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalOutstandingdebtGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Account Arrear</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalAccountInArrearGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Amount Arrear</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.amountarrearGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Account in good condition</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalaccountinGoodconditionGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Number of Judgement</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalNumberofJudgementGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Judgement Amount</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalJudgementAmountGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Last Judgement Date</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.lastJudgementDateGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Number of Dishonoured</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalNumberofDishonouredGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Dishonoured Amount</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalDishonouredAmountGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Last bounced cheque date</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.lastBouncedChequesDateGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Number of Accounts (GHS)</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalNumberofAccountsGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Active Accounts (GHS)</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalActiveAccountsGHS}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Total Closed Accounts (GHS)</td>
                <td className='px-4 py-3'>{report?.creditAccountSummary?.totalClosedAccountsGHS}</td>
            </tr>



            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'></td>
                <td className='px-4 py-3'></td>
            </tr>

            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3 font-bold text-gray-800 dark:text-gray-200'>Account Rating</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Home Loan Accounts (Good)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfHomeLoanAccountsGood}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Home Loan Accounts (Bad)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfHomeLoanAccountsBad}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Auto Loan Accounts (Good)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfAutoLoanccountsGood}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Auto Loan Accounts (Bad)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfAutoLoanccountsBad}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Study Loan Accounts (Good)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfStudyLoanAccountsGood}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Study Loan Accounts (Bad)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfStudyLoanAccountsBad}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Personal Loan Accounts (Good)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfPersonalLoanAccountsGood}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Personal Loan Accounts (Bad)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfPersonalLoanAccountsBad}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Credit Card Accounts (Good)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfCreditCardAccountsGood}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Credit Card Accounts (Bad)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfCreditCardAccountsBad}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Retail Accounts (Good)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfRetailAccountsGood}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Retail Accounts (Bad)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfRetailAccountsBad}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Joint Loan Accounts (Good)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfJointLoanAccountsGood}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Joint Loan Accounts (Bad)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfJointLoanAccountsBad}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Telecom Accounts (Good)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfTelecomAccountsGood}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Telecom Accounts (Bad)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfTelecomAccountsBad}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Other Accounts (Good)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfOtherAccountsGood}</td>
            </tr>

            <tr className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'>Number of Other Accounts (Bad)</td>
                <td className='px-4 py-3'>{report?.accountRating.noOfOtherAccountsBad}</td>
            </tr>



            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'></td>
                <td className='px-4 py-3'></td>
            </tr>

            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3 font-bold text-gray-800 dark:text-gray-200'>Credit Agreement Summary</td>
            </tr>

            {report?.creditAgreementSummary.map((item, index) => (
                <Fragment key={index + 20}>
                <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                    <td className='px-4 py-3 font-bold text-gray-800 dark:text-gray-200'>{index + 1}</td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Date Account Opened
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.dateAccountOpened}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Subscriber Name
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.subscriberName}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Account Number
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.accountNo}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Indicator Description
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.indicatorDescription}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Opening Balance Amount
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.openingBalanceAmt}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Currency
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.currency}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Current Balance Debt Indicator
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.currentBalanceDebitInd}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Current Balance Amount
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.currentBalanceAmt}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Installment Amount
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.instalmentAmount}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Amount Overdue
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.amountOverdue}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Closed Date
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.closedDate}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Changed on date
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.changedOnDate}
                    </td>
                </tr>
                </Fragment>
            ))}



            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3'></td>
                <td className='px-4 py-3'></td>
            </tr>

            <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                <td className='px-4 py-3 font-bold text-gray-800 dark:text-gray-200'>Account Monthly Payment History</td>
            </tr>

            {report?.accountMonthlyPaymentHistory.map((item, index) => (
                <Fragment key={index + 30}>
                <tr colSpan="2" className='px-4 py-6 border-b border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400'>
                    <td className='px-4 py-3 font-bold text-gray-800 dark:text-gray-200'>{index + 1}</td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Header
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.header}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Display Information
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.displayText}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Date Account Opened
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.dateAccountOpened}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Account Number
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.accountNo}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Currency
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.currency}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Repayment Frequency
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.repaymentFrequency}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Opening Balance Amount
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.openingBalanceAmt}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Current Balance Amount
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.currentBalanceAmt}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Installment Amount
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.instalmentAmount}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Amount Overdue
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.amountOverdue}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Closed Date
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.closedDate}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Last updated date
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.lastUpdatedDate}
                    </td>
                </tr>
                <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        Company
                    </td>
                    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                        {item?.company}
                    </td>
                </tr>
                <tr className='px-4 py-6 border-b'>
                    <td colSpan={2} className='px-4 py-3'>
                        <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 overflow-x-auto">
                            <div className="inline-block min-w-full shadow rounded-lg overflow-hidden">
                                <table className='min-w-full'>
                                    <thead className='text-xs font-semibold tracking-wide text-left text-white uppercase border-b bg-gray-700'>
                                        <tr>
                                            <th colSpan={2} className='px-4 py-3'>Previous Year</th>
                                            <th colSpan={2} className='px-4 py-3'>Current Year</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH24}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m24}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH01}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m01}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH23}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m23}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH02}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m02}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH22}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m22}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH03}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m03}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH21}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m21}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH04}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m04}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH20}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m20}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH05}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m05}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH19}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m19}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH06}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m06}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH18}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m18}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH07}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m07}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH17}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m17}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH08}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m08}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH16}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m16}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH09}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m09}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH15}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m15}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH11}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m11}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH14}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m14}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH12}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m12}</td>
                                        </tr>
                                        <tr className="px-4 py-6 border-b border-gray-100 dark:border-gray-700">
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH13}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m13}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.mH13}</td>
                                            <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{item?.m13}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </td>
                </tr>
                </Fragment>
            ))}
        </Fragment>
        }
        </>
    )
}

export default BureauReport